import { flow } from 'lodash';

import { NAME } from './monitoring.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
